import { ServerVars } from 'server-vars';
import { ABConfig } from './types/abTesting';

export const AB_TYPES = {
    CONTROL: 'CONTROL',
    VARIANT: 'VARIANT',
    INELIGIBLE: 'INELIGIBLE',
};

/**
 * Return the A/B configuration
 */
export const getConfig = (serverVars: ServerVars): ABConfig => {
    return serverVars.get('abTestConfig') || {};
};

export const getPageType = (serverVars: ServerVars): string => {
    return serverVars.get('settings').pageType || '';
};
